import React from "react";
import { Route } from "react-router-dom";
import OverviewPage from "./components/Overview/OverviewPage";
import BgpReflectorsPage from "./components/Reflector/ReflectorsPage";
import BgpVisibilityPage from "./components/BGP/BgpVisibilityPage";
import LicensingPage from "./components/Licensing/LicensingPage";
import UsersPage from "../settings/account/components/Users/UsersPage";
import CustomersPage from "../settings/account/components/Customers/CustomersPage";
import RequestPage from "../settings/support/RequestPage";
import ReflectorDetailsPage from "./components/Reflector/ReflectorDetails/ReflectorDetailsPage";
import ClusterPage from "./components/Reflector/Cluster/ClusterPage";
import ClusterDetailsPage from "./components/Reflector/Cluster/ClusterDetails/ClusterDetailsPage";
import ReportingPage from "./components/Reporting/ReportingPage";
import ReleasesPage from "./components/Releases/ReleasesPage";
import LogsPage from "./components/Logs/LogsPage";
import LogCollectorConfigPage from "./components/LogCollectorConfig/LogCollectorConfigPage";
import SystemStatusPage from "./components/SystemStatus/SystemStatusPage";
import InsightTopologyViewV2 from "../insight/views/InsightTopologyViewV2";
import { isInsightTopologyV2Enabled } from "@shared/config/featureFlags";

export const ctxReflectorV2Routes = [
  <Route key="overview" path="reflector-v2/overview" element={<OverviewPage />} />,
  // Legacy Network Topology (V1) lives under Insight (`/insight/topology`).
  // The NEW source-first Topology V2 product launches inside Reflector V2
  // (CTX-97, moved 2026-08-04) — same view component as
  // `/insight/topology-v2`, same env gate.
  ...(isInsightTopologyV2Enabled()
    ? [
        <Route
          key="reflector-v2-network-topology"
          path="reflector-v2/network-topology/*"
          element={<InsightTopologyViewV2 />}
        />,
      ]
    : []),
  <Route key="bgp-reflectors" path="reflector-v2/management/bgp-reflectors" element={<BgpReflectorsPage />} />,
  <Route key="bgp-reflector-details" path="reflector-v2/management/bgp-reflectors/details/:id" element={<ReflectorDetailsPage />} />,
  <Route key="bgp-visibility" path="reflector-v2/management/bgp-visibility" element={<BgpVisibilityPage />} />,
  <Route key="licensing" path="reflector-v2/management/licensing" element={<LicensingPage />} />,
  <Route key="admin-center-licensing" path="reflector-v2/admin-center/management/licensing" element={<LicensingPage />} />,
  <Route key="admin-center-releases" path="reflector-v2/admin-center/releases" element={<ReleasesPage />} />,
  <Route key="admin-center-log-collector-config" path="reflector-v2/admin-center/log-collector-config" element={<LogCollectorConfigPage />} />,
  <Route key="admin-center-system-status" path="reflector-v2/admin-center/system-status" element={<SystemStatusPage />} />,
  <Route key="payg" path="reflector-v2/management/licensing/payg" element={<LicensingPage />} />,
  <Route key="clusters" path="reflector-v2/management/clusters" element={<ClusterPage />} />,
  <Route key="cluster-details" path="reflector-v2/management/clusters/details/:id" element={<ClusterDetailsPage />} />,
  <Route key="reporting" path="reflector-v2/reporting" element={<ReportingPage />} />,
  <Route key="logs" path="reflector-v2/logs" element={<LogsPage />} />,
  <Route key="users" path="account/users" element={<UsersPage />} />,
  <Route key="customers" path="account/customers" element={<CustomersPage />} />,
  <Route key="request" path="request" element={<RequestPage />} />,
]; 